import { render, staticRenderFns } from "./noRecords.vue?vue&type=template&id=04f45fa7&"
import script from "./noRecords.vue?vue&type=script&lang=js&"
export * from "./noRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports